/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface MarkTargetNoteAsRead$Params {
  targetId?: number;
}

export function MarkTargetNoteAsRead(http: HttpClient, rootUrl: string, params?: MarkTargetNoteAsRead$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, MarkTargetNoteAsRead.PATH, 'post');
  if (params) {
    rb.query('targetId', params.targetId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

MarkTargetNoteAsRead.PATH = '/api/Supervisor/MarkTargetNoteAsRead';
